module.exports = __webpack_public_path__ + "static/media/new-job.4e536450.svg";